module.exports = __webpack_public_path__ + "img/hest12.ff66630e.jpg";